// frontend/src/components/ThreeDotsLoading.jsx
import { Box } from "@mui/material";
import { keyframes } from "@mui/system";
import useColors from "../api/hooks/useColors";

const ThreeDotsLoading = ({ size = 15 }) => {
  const colors = useColors();
  const loaderAnimation = keyframes`
  0%  {box-shadow: ${size * 2}px 0 ${colors.grey_600}, -${size * 2}px 0 ${
    colors.grey_400
  }; background: ${colors.grey_600} }
  33% {box-shadow: ${size * 2}px 0 ${colors.grey_600}, -${size * 2}px 0 ${
    colors.grey_400
  }; background: ${colors.grey_400}}
  66% {box-shadow: ${size * 2}px 0 ${colors.grey_400}, -${size * 2}px 0 ${
    colors.grey_600
  }; background: ${colors.grey_400}}
  100%{box-shadow: ${size * 2}px 0 ${colors.grey_400}, -${size * 2}px 0 ${
    colors.grey_600
  }; background: ${colors.grey_600} }
`;

  return (
    <Box
      display="flex"
      flexDirection={"row"}
      gap={0.2}
      width={`${size * 6}px`}
      alignContent={"center"}
      justifyContent={"center"}
    >
      <Box
        sx={{
          width: `${size}px`,
          aspectRatio: "1",
          borderRadius: "50%",
          animation: `${loaderAnimation} 1s infinite linear alternate`,
          "& *": {
            // Override the hardcoded colors with the provided color
            boxShadow: `${size}px 0 ${colors.grey_600}, -${size}px 0 ${colors.grey_600}`,
            background: colors.grey_600,
          },
        }}
      />
    </Box>
  );
};

export default ThreeDotsLoading;
